import React from 'react';

const ActionButtons = ({ onSubmit, hasChanges, isEditable = true, hasSubmittedCosting = false }) => {
	return (
		<div className="costing-summary-bottom border mb-3 p-3">
			{isEditable ? (
				<button
					className="button size32 w-100"
					onClick={onSubmit}
					disabled={hasSubmittedCosting || hasChanges}
				>
					<span className="regular-14 weight-500">Submit</span>
				</button>
			) : null}
		</div>
	);
};

export default ActionButtons;
